import AssistantChatRuntime from 'components/Chat/AssistantChatRuntime';
import ChatPanelView from 'components/Chat/ChatPanelView';
import { useWebsocket } from 'contexts/websocket';
import useChatPanelViewModel from 'hooks/chat/useChatPanelViewModel';
import { useEffect, useState } from 'react';
import { Loading } from 'shell/components';
import { ChatLayout } from 'utils/chat/chatConstants';

const ChatPanelRuntime = ({
    assistantIdentity = null,
    buildOutgoingRequest,
    chat,
    fileKey,
    hasOlderMessages,
    headerEndContent,
    headerStartContent,
    hideBackButton = false,
    hideComposer = false,
    isBootstrapping,
    isLoadingOlderMessages,
    isOpen,
    messageLayout = ChatLayout.DEFAULT,
    onBack,
    onChatRequestStateChange,
    onLoadOlderMessages,
    onSuggestionSelected,
    showSuggestions = false,
    suggestions = [],
    suggestionsTitle,
    suggestionsVariant,
    threadFallback = null,
    threadListAdapter,
    afterHeaderContent,
    viewModel,
}) => {
    const { isConnected, onMessage, sendMessage } = useWebsocket();
    const threadViewKey = chat?.id || chat?.local_id;
    const [shouldScrollThreadToBottom, setShouldScrollThreadToBottom] = useState(isOpen);

    useEffect(() => {
        if (!isOpen) {
            setShouldScrollThreadToBottom(false);
            return;
        }

        setShouldScrollThreadToBottom(true);
    }, [isOpen, threadViewKey]);

    useEffect(() => {
        if (!shouldScrollThreadToBottom) return;

        const frameId = requestAnimationFrame(() => {
            setShouldScrollThreadToBottom(false);
        });

        return () => {
            cancelAnimationFrame(frameId);
        };
    }, [shouldScrollThreadToBottom]);

    if (isBootstrapping || !threadViewKey) {
        return <Loading />;
    }

    return (
        <AssistantChatRuntime
            buildOutgoingRequest={buildOutgoingRequest}
            chat={chat}
            fileKey={fileKey}
            isConnected={isConnected}
            onChatRequestStateChange={onChatRequestStateChange}
            onMessage={onMessage}
            sendMessage={sendMessage}
            threadListAdapter={threadListAdapter}
        >
            <ChatPanelRuntimeContent
                assistantIdentity={assistantIdentity}
                hasOlderMessages={hasOlderMessages}
                headerEndContent={headerEndContent}
                headerStartContent={headerStartContent}
                hideBackButton={hideBackButton}
                hideComposer={hideComposer || Boolean(threadFallback)}
                isConnected={isConnected}
                isLoadingOlderMessages={isLoadingOlderMessages}
                messageLayout={messageLayout}
                onBack={onBack}
                onLoadOlderMessages={onLoadOlderMessages}
                onSuggestionSelected={onSuggestionSelected}
                afterHeaderContent={afterHeaderContent}
                shouldScrollThreadToBottom={shouldScrollThreadToBottom}
                threadViewKey={threadViewKey}
                showSuggestions={showSuggestions}
                suggestions={suggestions}
                suggestionsTitle={suggestionsTitle}
                suggestionsVariant={suggestionsVariant}
                threadFallback={threadFallback}
                viewModel={viewModel}
            />
        </AssistantChatRuntime>
    );
};

const ChatPanelRuntimeContent = (props) => {
    const viewModel = useChatPanelViewModel(props);

    return (
        <ChatPanelView
            {...viewModel}
            afterHeaderContent={props.afterHeaderContent}
            assistantIdentity={props.assistantIdentity}
            messageLayout={props.messageLayout}
            threadFallback={props.threadFallback}
        />
    );
};

export default ChatPanelRuntime;